import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f6ec671"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-results-count" }
const _hoisted_2 = {
  class: "search-results-count-number",
  "data-testid-number": ""
}
const _hoisted_3 = {
  class: "search-results-count-works",
  "data-testid-works": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.count && _ctx.count >= 0 ? _ctx.count : 0), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.count === 1 ? _ctx.$t("search.work") : _ctx.$t("search.works")), 1)
  ]))
}